<template>
  <div class="uk-margin">
    <label class="uk-form-label" :class="{ 'uk-form-danger': error }">{{ label }}<span v-if="shouldValidate">*</span></label>
    <div class="uk-form-controls">
    <label
        v-for="option in options"
        :key="option"
      >
        <input
          class="uk-radio"
          :class="[{ 'uk-form-danger': error }, 'uk-radio']"
          type="radio"
          :value="option"
          v-model="selected"
          @change="$emit('input', $event.target.value)"
        />
        <span v-html="option"></span><br>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['$validator'],
  inheritAttrs: false,
  props: {
    label: {
      required: true,
      Type: String
    },
    initialValue: {
      required: true
    },
    name: {
      required: true,
      Type: String
    },
    shouldValidate:{},
    error: {
      type: String,
      default: null
    },
    options: {
      required: false,
      type: Array,
      default: function() {
        return []
      }
    },
  },
  data() {
    return {
      selected: this.initialValue
    }
  },
  mounted() {
    this.$emit('input', this.initialValue)
  }
}
</script>
